import * as React from "react";
const SvgCmp = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 64 64", fill: "none", stroke: "currentColor", strokeWidth: 8, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M6,58l52,-52 M4,16h24M48,36v24M36,48h24" }));
export default SvgCmp;
